import axios from "axios";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { loginUser } from "~/shared/auth-utils";
import { readErrors } from "~/shared/utils";
import PublicPage from "./PublicPage";
import AlertBox from "~/shared/AlertBox";
import FormButton from "~/shared/form/FormButton";

export default function MFALogin() {
    const { token } = useParams();
    const history = useHistory();
    const [currentError, setCurrentError] = useState();

    useEffect(() => {
        login();
    }, []);

    async function login() {
        try {
            const response = await axios.post("auth/request-auth", { token });
            loginUser(response.data.token);
            history.push("/");
        } catch (error) {
            const [message] = readErrors(error);
            setCurrentError(message);
        }
    }

    return (
        <PublicPage title="MFA Login" forRole="ADMIN" navBar={[{ text: "Home", link: "/" }]}>
            {currentError ? <div>
                <AlertBox className="mt-3" type="error">{currentError}</AlertBox>
                <FormButton formless linkTo="/admin-portal" className="mb-3 mx-auto">Return to Login</FormButton>
            </div> : <div className="d-flex justify-content-center align-items-center my-5 gap-3">
                <Spinner animation="border" /> <h2>Logging in...</h2>
            </div>}
        </PublicPage>
    );
}